export const getEventPath = (event: Event): HTMLElement[] => {
  return getElementPath(<HTMLElement>event.target);
};

const getElementPath = (sourceEl: HTMLElement) => {
  const getPathInternal = (el: HTMLElement, path = []) => {
    if (!el.parentElement) return path;
    return getPathInternal(el.parentElement, [...path, el.parentElement]);
  };
  return getPathInternal(sourceEl, [sourceEl]);
};

export const getNodePath = (sourceEl: Node): Node[] => {
  const getPathInternal = (el: Node, path = []) => {
    if (!el.parentNode) return path;
    return getPathInternal(el.parentNode, [...path, el.parentNode]);
  };
  return getPathInternal(sourceEl, [sourceEl]);
};
